import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { CardUserPhoto, TeamCardPhotoComponent } from '@app/shell/team-card-photo/team-card-photo.component';

@Component({
  selector: 'app-team-card-list',
  standalone: true,
  imports: [CommonModule, PaginatorModule, TeamCardPhotoComponent],
  templateUrl: './team-card-list.component.html',
  styleUrls: ['./team-card-list.component.scss'],
})
export class TeamCardListComponent {

  @Input() items: CardUserPhoto[] = [];
  @Input() totalSize: number;
  @Input() isTeamList: boolean;
  @Input() isPagination: boolean = true;

  @Output() changePage: EventEmitter<any> = new EventEmitter<any>();
  @Output() redirectToDetail: EventEmitter<number> = new EventEmitter<number>();

}
